import { ExchangeCurrencyModelType, MultiExchangeCurrencyModelType } from './types';
import { ExchangeCurrencyApiType, MultiExchangeCurrencyApiType } from '@project/services';

export const ExchangeCurrencyModel = (
  data: ExchangeCurrencyApiType,
): ExchangeCurrencyModelType => ({
  convertedAmount: Number(data?.converted_amount ?? -1),
});

export const ExchangeCurrencyModelArray = (
  data: MultiExchangeCurrencyApiType,
): MultiExchangeCurrencyModelType => ({
  tip: {
    amount: Number(data.tip.amount),
    currency: data.tip.from_currency,
    amountCurrency: data.tip.to_currency,
  },
  sponsorMagazine: {
    amount: Number(data.sponsor_magazine.amount),
    currency: data.sponsor_magazine.from_currency,
    amountCurrency: data.sponsor_magazine.to_currency,
  },
});
